// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__AQgw1","title":"FrontImage_title__2JReH"};